import React from 'react';
import { Link } from 'react-router-dom';
import { useLegalDraftStatus } from '@/config/legalStatus';

const LegalFooterLinks = () => {
  const isDraft = useLegalDraftStatus();
  const suffix = isDraft === true ? ' (draft)' : '';
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 justify-center" data-testid="footer-legal-links">
      <Link to="/disclaimer" className="text-sm text-muted-foreground hover:underline" data-testid="footer-disclaimer-link">Disclaimer{suffix}</Link>
      <Link to="/terms" className="text-sm text-muted-foreground hover:underline" data-testid="footer-terms-link">Terms of Use{suffix}</Link>
      <Link to="/privacy-policy" className="text-sm text-muted-foreground hover:underline" data-testid="footer-privacy-link">Privacy Policy{suffix}</Link>
      <Link to="/cookie-settings" className="text-sm text-muted-foreground hover:underline" data-testid="footer-cookie-link">Cookie Settings</Link>
    </div>
  );
};

export default LegalFooterLinks;
